//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapActions, mapState } from "vuex";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQMonacoEditor from "@/components/Generics/AQMonacoEditor/AQMonacoEditor.vue";
import DataModel from "@/components/UserInterfaces/mixins/datamodel-utils";

export default {
    components: {
        AQButton,
        AQModal,
        AQDialog,
        AQMonacoEditor
    },
    mixins: [DataModel],
    props: {
        value: {
            type: String,
            default: ""
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dataSuggestions: [],
            globalSuggestions: "",
            catalogList: [],
            suggestionsTypeList: [
                { type: "modelClasses", typeSymbol: "m_", detail: "MOD", sortText: "a" },
                { type: "systemVariables", typeSymbol: "s_", detail: "VAR", sortText: "b" }
            ],
            contentNotValid: false,
            showConfirm: false,
            dialogTypeAction: "close",
            monacoData: "",
            initialData: "",
            showModal: false,
            type: "JavaScript",
            headerActionsModal: [{
                label: this.$t("generic.delete"),
                value: "delete"
            }]
        };
    },
    computed: {
        ...mapState("components", ["parsed"]),
        hasSave() {
            return {
                label: this.$t("generic.done"),
                disabled: this.readonly || this.hasEmptyContent
            };
        },
        showConfig() {
            return !this.monacoData;
        },
        getDialogTitle() {
            return this.$t(`diagrams.components.advancedLogic.${this.dialogTypeAction}Title`);
        },
        getDialogBody() {
            return this.$t(`diagrams.components.advancedLogic.${this.dialogTypeAction}Msg`);
        },
        isDisabled() {
            return this.readonly || !this.initialData;
        },
        hasEmptyContent() {
            return !this.monacoData || !this.monacoData.trim();
        },
        getSaveTooltip() {
            return this.hasEmptyContent ? this.$t("diagrams.components.advancedLogic.emptyMsg") : "";
        }
    },
    watch: {
        value: {
            handler(newValue) {
                if (newValue) {
                    this.monacoData = newValue;
                    this.initialData = newValue;
                } else {
                    this.initialData = "";
                }
            },
            immediate: true

        }
    },
    mounted() {
        const waitPromise = this.loadDataModel();
        waitPromise.then(() => {
            this.getSuggestions();
        });
    },
    methods: {
        ...mapActions("components", ["getDataModelLatestVersion"]),
        loadDataModel() {
            return new Promise(resolve => {
                let dataModel;
                let externalModel;

                this.getDataModelLatestVersion().then(() => {
                    dataModel = new Promise(resolveDataModel => {
                        this.getRawDataModel().then(() => {
                            this.parseCatalogsRawData();
                            this.parseModelClassesRawData();
                            resolveDataModel();
                        });
                    });

                    externalModel = new Promise(resolveExternal => {
                        Promise.all([this.getRawExternalAPIs(), this.getRawSystemVariables()])
                            .then(([rawExternalAPIs, rawSystemVariables]) => {
                                this.parseAPIsRawData(rawExternalAPIs);
                                this.parseSystemVariables(rawSystemVariables);
                                resolveExternal();
                            });
                    });

                    Promise.all([dataModel, externalModel]).then(() => {
                        resolve();
                    });
                });
            });
        },
        getSuggestions() {
            if (this.parsed) {
                // eslint-disable-next-line max-len
                let getNewModel = "interface ajaxCallParameters { url: String, method?:String, data?:any }\r\n function ajaxCall ({url, method, data}:ajaxCallParameters) { return new Promise((resolve, reject) => { if (url) { resolve(); } else { reject(); }})}; \r\n function loadScript (url: String) { return new Promise((resolve, reject) => { if (url) { resolve(); } else { reject(); }})}; \r\n let mssql \r\n";
                // eslint-disable-next-line max-len
                getNewModel += "function microsoftSqlConnect(config: string) { return new Promise((resolve, reject) => { if (config) { resolve(); } else { reject(); }})}; \r\n function microsoftSqlQuery(query: string) { return new Promise((resolve, reject) => { if (query) { resolve(); } else { reject(); }})}; \r\n";
                // eslint-disable-next-line max-len
                getNewModel += "function btoa(str) {  return new Buffer(str, 'binary').toString('base64'); }; \r\n function atob(b64Encoded) {  return new Buffer(b64Encoded, 'base64').toString('binary'); }";
                // eslint-disable-next-line max-len
                getNewModel += "function dataStoreGet (tableCode: string, selectedColumns?: Array<string>, filterConditions?: Array<{column: string; operator: string; value: any;} | {operator: string;}>, pagination?: {pageNumber: number; pageItems: number}): Promise<{data: {tableCode: string; filterCondition: Array<{column: string; operator: string; value: any;} | {operator: string;}>; pagination: {pageNumber: number; pageItems: number;}; totalRecords: number; totalPages: number; records: Array<any>}}>";
                // eslint-disable-next-line max-len
                getNewModel += "function dataStoreGetAudit (tableCode: string, selectedColumns?: Array<string>, filterConditions?: Array<{column: string; operator: string; value: any;} | {operator: 'AND'|'OR';}>, pagination?: {pageNumber: number; pageItems: number}): Promise<{tableCode: string; pagination: {pageNumber: number; pageItems: number;}; totalRecords: number; totalPages: number; auditRecords: Array<{event: string, id: number, eventDate: string, modifiedBy: string, modifiedVia: string, processInstanceId: string | null, newData: object | null, oldData: object | null}>}>";
                getNewModel += "function dataStoreAdd(tableCode: string, data: Array<Object>): Promise<{data:{totalAdded: number, recordsIds: Array<number>}}>";
                // eslint-disable-next-line max-len
                getNewModel += "function dataStoreUpdateByCondition(tableCode: string, filterConditions: Array<{column: string; operator: string; value: any;} | {operator: string;}>, data: Object): Promise<{data: {totalUpdated: number}}>";
                getNewModel += "function dataStoreUpdateByKey(tableCode: string, keyColumn: string, updates: Object): Promise<{data:{totalUpdated: number}}>";
                // eslint-disable-next-line max-len
                getNewModel += "function dataStoreDelete(tableCode: string, filterConditions: Array<{column: string; operator: string; value: any;} | {operator: string;}>): Promise<{data: {totalDeleted: number;}}>";
                this.dataSuggestions = [
                    { label: "ajaxCall",
                        kind: "Function",
                        detail: "function ajaxCall({url, method, data}:ajaxCallParameters): Promise<any>",
                        sortText: "1",
                        value: "ajaxCall().then(\r\n\x20response => {\r\n\x20\r\n\x20})\r\n" },
                    { label: "loadScript",
                        kind: "Function",
                        detail: "function loadScript(url): Promise<any>",
                        sortText: "1",
                        value: "loadScript().then(\r\n\x20response => {\r\n\x20\r\n\x20})\r\n" },
                    { label: "btoa",
                        kind: "Function",
                        detail: "function btoa(str) {  return new Buffer(str, 'binary').toString('base64'); }",
                        sortText: "1",
                        value: "btoa()\r\n" },
                    { label: "atob",
                        kind: "Function",
                        detail: "function atob(b64Encoded) {  return new Buffer(b64Encoded, 'base64').toString('binary'); }",
                        sortText: "1",
                        value: "atob()\r\n" },
                    { label: "microsoftSqlConnect",
                        kind: "Function",
                        detail: "function microsoftSqlConnect(config): Promise<any> }",
                        sortText: "1",
                        value: "microsoftSqlConnect().then(\r\n\x20response => {\r\n\x20\r\n\x20})\r\n" },
                    { label: "microsoftSqlQuery",
                        kind: "Function",
                        detail: "function microsoftSqlQuery(query): Promise<any> }",
                        sortText: "1",
                        value: "microsoftSqlQuery().then(\r\n\x20response => {\r\n\x20\r\n\x20})\r\n" }
                ];
                const setGlobal = (v, type) => {
                    Object.entries(v || {}).forEach(([key, value]) => {
                        if (type) {
                            getNewModel += `let ${key} = ${JSON.stringify(value)};\r\n`;
                        } else {
                            getNewModel += `const ${key} = Object.freeze(${JSON.stringify(value)});\r\n`;
                        }
                    });
                };

                Object.entries(this.parsed.catalogs || {}).forEach(([key]) => {
                    this.catalogList.push(key);
                });

                this.suggestionsTypeList.forEach(({ type, typeSymbol, detail, sortText }) => {
                    const newData = {};
                    this.searchForData(this.parsed[type], typeSymbol, detail, sortText, newData, true);
                    setGlobal(newData, typeSymbol === "m_");
                });
                this.globalSuggestions = getNewModel;
            }
        },
        searchForData(data, typeSymbol, detail, sortText, container, parent) {
            Object.entries(data || {}).forEach(([, value]) => {
                const newPropList = value.key.split(".");
                const newProp = newPropList[newPropList.length - 1];
                const typeVar = parent ? `${typeSymbol}${newProp}` : newProp;
                if (!this.catalogList.includes(value.type) && value.fields) {
                    this.searchForData(value.fields, typeSymbol, detail, sortText, container[typeVar] = value.isList ? [] : {});
                } else {
                    const getValue = (isList) => {
                        let newValue = "";
                        const { type } = value;
                        if (isList) {
                            newValue = [];
                        } else if (["Integer", "Decimal"].includes(type)) {
                            newValue = 0;
                        } else if (type === "Boolean") {
                            newValue = false;
                        }
                        return newValue;
                    };
                    let customValue;
                    if (Array.isArray(container)) {
                        container.push({ [typeVar]: getValue(this.catalogList.includes(value.type) && value.isList) });
                        const newValue = newPropList.slice(0, -1).reduce((total, prop) => (total ? `${total}.${prop}` : prop), "");
                        customValue = `${newValue}[0].${newProp}`;
                    } else if (this.catalogList.includes(value.type) && value.isList) {
                        container[typeVar] = getValue(true);
                    } else {
                        container[typeVar] = getValue();
                    }

                    this.dataSuggestions.push({ label: `${typeSymbol}${customValue || value.key}`,
                        detail,
                        value: `${typeSymbol}${customValue || value.key}`,
                        sortText });
                }
            });
        },
        openDetails() {
            if (!this.readonly) {
                this.showModal = true;
                this.initialData = this.monacoData;
            }
        },
        actionModal(action) {
            const setAction = v => {
                this.dialogTypeAction = v;
                this.showConfirm = true;
            };
            if (action === "primary") {
                if (this.contentNotValid) {
                    setAction("save");
                } else {
                    this.$emit("input", this.monacoData);
                    this.showModal = false;
                }
            } else if (action === this.$t("generic.delete")) {
                setAction("delete");
            } else if (action === "close") {
                if (this.initialData !== this.monacoData) {
                    setAction("close");
                } else {
                    this.monacoData = this.initialData;
                    this.showModal = false;
                }
            }
        },
        okConfirm() {
            if (this.dialogTypeAction === "delete") {
                this.monacoData = "";
                this.initialData = "";
                this.$emit("input");
                this.dialogTypeAction = "close";
            } else if (this.dialogTypeAction === "save") {
                this.$emit("input", this.monacoData);
                this.showModal = false;
                this.$toast.showNotify({
                    type: "success",
                    message: this.$t("diagrams.components.advancedLogic.successMsg")
                });
            } else {
                this.monacoData = this.initialData;
            }
            this.showModal = false;
        }
    }
};
